module.exports = __webpack_public_path__ + "img/avatar.d26eccf1.jpg";